import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { Box } from '@mui/material';

const ColumnChartSuperavitDefasagem = ({ rawData }) => {
  const anos = rawData.map((item) => `${item.year}`);
  const ipca = rawData.map((item) => item.ipca_value);
  const superavit = rawData.map((item) => item.superavit_defasagem_value);
  const ajuste = rawData.map((item) => item.table_adjustment);

  const series = [
    {
      data: ipca,
      type: 'line',
      name: '% do IPCA Nacional',
      lineStyle: {
        color: '#cb5055',
        width: 2,
      },
      itemStyle: {
        color: '#72111d',
      },
      symbol: 'circle',
      symbolSize: [12, 12],
      smooth: true,
      label: {
        show: true,
        position: 'top',
        formatter: (params) => `${params.value}%`,
      },
    },
    {
      data: superavit,
      type: 'line',
      name: 'Superavit ou defasagem',
      lineStyle: {
        color: '#000',
        width: 2,
      },
      itemStyle: {
        color: '#000',
      },
      symbol: 'circle',
      symbolSize: [12, 12],
      smooth: true,
      label: {
        show: true,
        position: 'bottom',
        formatter: (params) => `${params.value}%`,
      },
    },
    {
      data: ajuste,
      type: 'line',
      name: '% de Ajuste na Tabela Escola',

      lineStyle: {
        color: '#269f5a',
        width: 2,
      },
      itemStyle: {
        color: '#066347',
      },

      symbol: 'circle',
      symbolSize: [12, 12],
      smooth: true,
      label: {
        show: true,
        position: 'top',
        formatter: (params) => `${params.value}%`,
      },
    },
  ];

  const option = {
    title: {
      text: 'Superávit ou defasagem entre % de ajuste da escola X IPCA',
      textStyle: {
        fontSize: '14px',
      },
    },
    legend: {
      data: ['% do IPCA Nacional', 'Superavit ou defasagem', '% de Ajuste na Tabela Escola'],
      right: '0',
    },
    grid: {
      top:'20%',
      bottom:'15%',
      left: '3%',
      right: '2%'
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: (value) => `${value}%`, 
      },
    },
    xAxis: {
      type: 'category',
      data: anos,
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'} p={2}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartSuperavitDefasagem;
